import React from 'react'
import { observer } from 'mobx-react'
import { payPlanMobx } from '@mobx/mall/payment'
import PaypalSimpleItem from './SimpleItem'

const PayPalMethodItem = ({ selected }: { selected?: boolean }) => {
  const amount = payPlanMobx.externalMethod?.amount

  return (
    <PaypalSimpleItem selected={selected} amount={amount} onChange={() => payPlanMobx.changeExternalPayMethod('PayPalWeb')} />
  )
}

export default observer(PayPalMethodItem)
